firebird.controller('browserOrAppNotSupportedCtrl', [
    'logService',
    'camaroHelperService',
    'brandingService',
    'helperService',
    'meetingService',
    '$location',
    function (logService, camaroHelperService, brandingService, helperService, meetingService, $location) {
        var self = this;

        const logger = new LogServiceWrapper(logService, 'browserOrAppNotSupportedCtrl');
        const webinarType = 'webinar';

        self.isWebinar = false;
        self.isMac = false;
        self.isNotAuthorizedUniteReady = false; // TODO: Set TRUE after release Unite without authorization
        self.uniteDtAppDisplayName = '';
        self.mobileMeetingAppName = '';
        self.camaroAppName = '';
        self.uniteDtAppLogo = '';
        self.googleChromeDownloadUrl = 'https://www.google.com/chrome/browser/';
        self.edgeDownloadUrl = 'https://www.microsoft.com/en-us/edge/download';

        self.getMeetingTitle = getMeetingTitle;
        self.getMeetingLink = getMeetingLink;
        self.getMeetingLinkLabel = getMeetingLinkDisplayTitle;
        self.startUniteAppDownload = startUniteAppDownload;
        self.copyMeetingLinkToClipboard = copyMeetingLinkToClipboard;
        self.getUniteDownloadUrl = getUniteDownloadUrl;
        self.getMobileAppDownloadUrl = getMobileAppDownloadUrl;
        self.getAppDetectionFailed = getAppDetectionFailed;

        init();

        function init() {
            logger.log('init', 'init browserOrAppNotSupportedCtrl');

            self.uniteDtAppLogo = brandingService.getUniteDtAppLogo();
            self.uniteDtAppDisplayName = brandingService.getUniteDtAppName();
            self.mobileMeetingAppName = brandingService.getCamaroAppName();
            self.camaroAppName = brandingService.getCamaroAppName();
            self.isWebinar = _getIsWebinar();
            self.isNotAuthorizedUniteReady = helperService.isUniteWithoutAuthReleased(
                brandingService.getResellerCode()
            );
            self.isMac = helperService.isMac();
        }

        function getUniteDownloadUrl() {
            camaroHelperService.setupDownloadLocation();
            return camaroHelperService.uniteAppDownloadLocation;
        }

        function getMobileAppDownloadUrl() {
            const meetingIdentifier = helperService.getRawMeetingIdentifier($location.absUrl());
            return brandingService.getMobileAppDownloadUrl(meetingIdentifier);
        }

        function getAppDetectionFailed() {
            return camaroHelperService.detectionState === 'failed';
        }

        function startUniteAppDownload() {
            logger.log(
                'startUniteAppDownload',
                'Camaro Detector Ctrl - Starting Unite App Download',
                camaroHelperService.uniteAppDownloadLocation
            );
            window.location.href = camaroHelperService.uniteAppDownloadLocation;
        }

        function copyMeetingLinkToClipboard() {
            if (!navigator.clipboard) {
                logger.error('copyMeetingLinkToClipboard', 'Clipboard API is unavailable');
                return;
            }

            let meettingLink = getMeetingLink();
            return navigator.clipboard.writeText(meettingLink);
        }

        function getMeetingLinkDisplayTitle() {
            const host = window.location.hostname;
            const meetingIdentifier = helperService.getRawMeetingIdentifier($location.absUrl());
            return `${host}/${meetingIdentifier}`;
        }

        function getMeetingLink() {
            return window.location.href;
        }

        function getMeetingTitle() {
            return meetingService.getTitle();
        }

        function _getIsWebinar() {
            return helperService.getMeetingTypeByDomain() === webinarType;
        }
    }
]);
